<!--Header-->
<div class="only-print">
	<div class="container p-lg-0">
		<nav class="navbar navbar-black text-white p-lg-0">
			<a class="navbar-brand brand-bert">BERTAZZONI</a>
		</nav>
	</div>
</div>

<!--content cart-->
<div class="container mt-5 px-lg-0">
	<div class="row no-gutters flex-row-reverse">
		<div class="col-12 d-lg-none mt-5 no-print">
			<div class="d-flex align-items-center justify-content-between">
				<h6 class="mr-4 mb-0">Shipping address:</h6>
				<div class="mb-0 form-group">
					<select
						class="w-100 rounded-0 border-black minimal"
						name="indMobile"
						[(ngModel)]="codiceIndirizzo"
						(ngModelChange)="indirizzoChange($event)">
						<option *ngIf="!indirizzi.length" [value]="null">
							{{utente.cliente.indirizzo}}, {{utente.cliente.localita}} {{utente.cliente.provincia}}, {{utente.cliente.cap}}
						</option>
						<option *ngFor="let indirizzo of indirizzi" [value]="indirizzo.codiceCliente">
							{{indirizzo.indirizzo}}, {{indirizzo.localita}} {{indirizzo.provincia}}, {{indirizzo.cap}}
						</option>
					</select>
				</div>
			</div>
			<div class="mb-5 mt-3 font-12">
				<span>Do you need to change or add a shipping address?</span>
				<span>
					<a class="ml-2 text-underline font-italic">Contact Bertazzoni</a>
					.
				</span>
			</div>
		</div>
		<div class="col-lg-3 mt-5 no-print">
			<!-- BOX ACQUISTA -->
			<span *ngIf="carrello.length > 0">
				<div class="border border-black border-bottom-0 p-3">
					<button
						type="button"
						class="btn btn-bertazzoni black btn-block rounded-0 py-2"
						[disabled]="buyDisabled"
						(click)="buy(modaleDataRichiesta, confirm)">
						BUY NOW
					</button>
					<div class="d-flex align-items-center justify-content-between my-3">
						<div>
							<p class="mb-0">Order total</p>
							<p class="mb-0">({{totaleItems}} articles):</p>
						</div>
						<p class="font-semibold font-20 mb-0">{{ '' | valuta }} {{totaleSoldi | number}}</p>
					</div>
					<p>Click on “Buy Now” if you want to confirm the cart to Bertazzoni.</p>
				</div>
				<div class="row no-gutters mb-4">
					<div class="col-6">
						<button class="btn btn-bertazzoni black btn-block rounded-0 py-2" (click)="print()">
							<span class="icon-printing-tool font-18"></span>
						</button>
					</div>
					<div class="col-6">
						<button
							class="btn btn-bertazzoni black btn-block rounded-0 py-2"
							style="border-left-color: white;"
							(click)="openMail(contentMail)">
							<span class="icon-mail font-18"></span>
						</button>
					</div>
				</div>
			</span>
			<!-- SHOP BY CODE -->
			<app-shop-by-code></app-shop-by-code>
			<!-- IMPORT EXCEL -->
			<app-import-excel></app-import-excel>

			<div class="border border-black p-3 mb-4" *ngIf="carrello.length > 0 && showContainerizzazione">
				<div class="row">
					<div class="col-12">
						<button type="button" class="btn btn-bertazzoni black btn-block rounded-0 py-2" (click)="viewContainer()">
							View container
						</button>
					</div>
				</div>
			</div>
		</div>
		<div class="col-lg-9 mt-5">
			<div class="d-lg-flex align-items-center d-none no-print">
				<div class="d-flex align-items-center justify-content-between">
					<h6 class="mr-4 mb-0">Shipping address:</h6>
					<div class="form-group mb-0">
						<select
							class="w-100 rounded-0 border-black minimal"
							name="indDesk"
							[(ngModel)]="codiceIndirizzo"
							(ngModelChange)="indirizzoChange($event)">
							<option *ngIf="!indirizzi.length" [ngValue]="null">
								{{utente.cliente.indirizzo}}, {{utente.cliente.localita}} {{utente.cliente.provincia}}, {{utente.cliente.cap}}
							</option>
							<option *ngFor="let indirizzo of indirizzi" [value]="indirizzo.codiceCliente">
								{{indirizzo.indirizzo}}, {{indirizzo.localita}} {{indirizzo.provincia}}, {{indirizzo.cap}}
							</option>
						</select>
					</div>
				</div>
			</div>
			<div class="mb-5 mt-3 font-12 d-none d-lg-block no-print">
				<span>Do you need to change or add a shipping address?</span>
				<span><a class="ml-2 text-underline">Contact Bertazzoni.</a></span>
			</div>
			<div class="row no-print">
				<div class="col-9">
					<p class="font-20 mb-4" *ngIf="carrello.length > 0">Check your articles:</p>
					<p class="font-20 mb-4" *ngIf="carrello.length === 0 && !success">Cart is empty</p>
					<p class="font-20 mb-4" *ngIf="carrello.length === 0 && success">
						Order sent successfully, do you want to proceed with a new order?
						<a class="text-underline font-italic" routerLink="/">Click Here</a>
					</p>
				</div>
				<div class="col-3" *ngIf="carrello.length > 0">
					<label class="label mb-4 float-right mr-5">
						<input class="checkbox" type="checkbox" group="qColore" name="c-view" [(ngModel)]="hideImages" />
						<b>Compact view</b>
					</label>
				</div>
			</div>
			<div class="mr-lg-5" *ngIf="carrello.length > 0">
				<div class="border p-3 mb-4" *ngFor="let item of carrello">
					<div class="row align-items-center">
						<!-- IMMAGINI -->
						<div class="col-lg-3 col-5 col-img-stampa" *ngIf="!hideImages">
							<img class="img-stampa" *ngIf="item.prodottoCommerciale.immagini.length == 0" src="assets/img/no-img.png" />
							<img
								class="img-stampa"
								*ngIf="item.prodottoCommerciale.immagini.length >= 1"
								[src]="item.prodottoCommerciale.immagini[item.prodottoCommerciale.imgIndex]?.path | img" />
							<div class="text-center" *ngIf="item.prodottoCommerciale.immagini.length > 1">
								<img
									src="assets/img/back.svg"
									class="tracking carousel-icon m-2 no-print"
									onmouseover="this.src='assets/img/back-w.svg'"
									onmouseout="this.src='assets/img/back.svg'"
									(click)="item.prodottoCommerciale.imgIndex = item.prodottoCommerciale.imgIndex-1"
									*ngIf="item.prodottoCommerciale.imgIndex>0" />
								<img
									src="assets/img/next.svg"
									class="tracking carousel-icon m-2 no-print"
									onmouseover="this.src='assets/img/next-w.svg'"
									onmouseout="this.src='assets/img/next.svg'"
									(click)="item.prodottoCommerciale.imgIndex = item.prodottoCommerciale.imgIndex+1"
									*ngIf="item.prodottoCommerciale.imgIndex+1 < item.prodottoCommerciale.immagini.length" />
							</div>
						</div>

						<div [ngClass]="hideImages ? 'col-lg-9 col-12' : 'col-lg-9 col-7'">
							<div class="d-lg-flex justify-content-between">
								<!-- SCHEDA PRODOTTO -->
								<div [ngClass]="hideImages ? 'col-12' : 'col-lg-9 col-12'">
									<p class="font-18 font-semibold">{{getDescrizione(item.prodottoCommerciale)?.valore}}</p>
									<p class="font-16 mb-0" *ngIf="!item.prodottoCommerciale.isNeutral">
										{{item.prodottoCommerciale.prodotto.lineaEstetica | translate | titlecase}} Series
									</p>
									<p class="text-secondary mb-0">{{item.prodottoCommerciale.codiceCommerciale}}</p>
									<p class="text-secondary" [class.mb-0]="hideImages" *ngIf="item.prodottoCommerciale.tipoGas">
										{{item.prodottoCommerciale.tipoGas}}
									</p>
									<p class="text-secondary" *ngIf="item.leadTimeCalcolato">
										<b>Lead Time:</b>
										{{item.leadTimeCalcolato | date:'shortDate'}}
									</p>
								</div>
								<!-- PREZZI -->
								<div class="text-lg-right d-lg-block d-flex" [ngClass]="hideImages ? 'col-lg-4 col-12' : 'col-lg-3 col-12'">
									<p class="font-20 font-semibold no-print">{{ '' | valuta }} {{getPrezzo(item) * item.quantita | number}}</p>
									<p class="font-18">{{item.quantita | number}}x{{getPrezzo(item)}}</p>
									<!-- Versione compatta -->
									<div class="col-lg-12 col-7 float-right pr-0 ml-auto no-print" *ngIf="hideImages">
										<ng-container *soloUsa>
											<p *ngIf="item.prodottoCommerciale.giacenzaMagazzino > 0" class="font-14 mb-0 font-semibold text-success text-right">
												{{item.prodottoCommerciale.giacenzaMagazzino}} items available
											</p>
											<p
												*ngIf="item.prodottoCommerciale.giacenzaMagazzino === 0"
												class="font-14 mb-0 font-semibold text-secondary text-right">
												Unavailable
											</p>
										</ng-container>
										<ng-container *nonUsa>
											<p
												class="font-14 mb-0 font-semibold"
												style="color: red;"
												*ngIf="item.prodottoCommerciale.statoGiacenza === 'IN_STOCK'">
												Product in phase-Out: {{item.prodottoCommerciale.giacenza}} pcs. In Stock
											</p>
										</ng-container>
										<p class="font-14 mb-0 font-semibold mb-1" style="color: red;" *ngIf="item.erroreMoq">
											Minimum order quantity: {{item.prodottoCommerciale.moqVendita}} pcs.
										</p>
										<div class="d-flex">
											<div class="number-input">
												<button class="btn btn-link text-black text-underline font-12 py-0" (click)="delete(item)">Delete</button>
												<div (click)="$updateQuantita.emit({item: item, qta: item.quantita - 1})" class="selettore-spin"></div>
												<input
													class="quantity form-bertazzoni"
													min="1"
													max="100"
													name="quantity"
													value="1"
													type="number"
													[(ngModel)]="item.quantita"
													(ngModelChange)="$updateQuantita.emit({item: item, qta: $event})"
													required />
												<div (click)="$updateQuantita.emit({item: item, qta: item.quantita + 1})" class="selettore-spin plus"></div>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>

					<div class="row">
						<div class="col-lg-9 ml-lg-auto no-print" *ngIf="!hideImages">
							<div class="d-flex align-items-end">
								<button class="ml-auto btn btn-link text-black text-underline font-12 py-0" (click)="delete(item)">Remove item</button>
								<div class="col-lg-4 col-5">
									<ng-container *soloUsa>
										<p *ngIf="item.prodottoCommerciale.giacenzaMagazzino > 0" class="font-14 mb-0 font-semibold text-success text-center">
											{{item.prodottoCommerciale.giacenzaMagazzino}} items available
										</p>
										<p
											*ngIf="item.prodottoCommerciale.giacenzaMagazzino === 0"
											class="font-14 mb-0 font-semibold text-secondary text-center">
											Unavailable
										</p>
									</ng-container>
									<ng-container *nonUsa>
										<p class="font-14 mb-0 font-semibold" style="color: red;" *ngIf="item.prodottoCommerciale.statoGiacenza === 'IN_STOCK'">
											Product in phase-Out: {{item.prodottoCommerciale.giacenza}} pcs. In Stock
										</p>
									</ng-container>
									<p class="font-14 mb-0 font-semibold mb-1" style="color: red;" *ngIf="item.erroreMoq">
										Minimum order quantity: {{item.prodottoCommerciale.moqVendita}} pcs.
									</p>
									<div class="d-flex">
										<div class="number-input">
											<div (click)="$updateQuantita.emit({item: item, qta: item.quantita - 1})" class="selettore-spin noselect"></div>
											<input
												class="quantity form-bertazzoni"
												min="1"
												max="100"
												name="quantity"
												value="1"
												type="number"
												[(ngModel)]="item.quantita"
												(ngModelChange)="$updateQuantita.emit({item: item, qta: $event})"
												required />
											<div (click)="$updateQuantita.emit({item: item, qta: item.quantita + 1})" class="selettore-spin plus noselect"></div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>

				<div class="d-flex justify-content-end align-items-center mb-4">
					<div class="col-lg-3 pr-0 mr-auto no-print">
						<button class="btn btn-bertazzoni black btn-block rounded-0" (click)="svuota()">CLEAR</button>
					</div>
					<div class="px-4">
						<p class="mb-1 text-16">
							Order Total ({{totaleItems}} articles):
							<span class="font-20 font-semibold">{{ '' | valuta }} {{totaleSoldi | number}}</span>
						</p>
					</div>
					<div class="col-lg-3 pr-0 no-print">
						<button
							class="btn btn-bertazzoni black btn-block rounded-0"
							[disabled]="buyDisabled"
							(click)="buy(modaleDataRichiesta, confirm)">
							BUY NOW
						</button>
					</div>
				</div>
				<p class="mb-5 no-print">Click on “Buy Now” if you want to confirm the cart to Bertazzoni.</p>
			</div>
		</div>
	</div>

	<ng-template #modaleDataRichiesta let-modal>
		<div class="modal-header">
			<h5 class="modal-title" id="">Requested Departure Date</h5>
			<button type="button" class="close" aria-label="Close" (click)="modal.close()">
				<span aria-hidden="true">&times;</span>
			</button>
		</div>
		<div class="modal-body">
			<div class="col-12">
				<ngb-datepicker [(ngModel)]="dateSelected" [displayMonths]="1" [dayTemplate]="t" outsideDays="hidden"></ngb-datepicker>
			</div>
			<div class="col-12 mt-2">
				<input
					type="text"
					class="form-control mb-2 rounded-0 form-bertazzoni white"
					placeholder="CUSTOMER ORDER REFERENCE*"
					name="rifOrdineCliente"
					maxlength="20"
					[(ngModel)]="rifOrdineCliente"
					required />
			</div>
		</div>
		<div class="modal-footer">
			<button type="button" class="btn btn-bertazzoni white rounded-0 py-2" (click)="modal.close()">Close</button>
			<button
				type="button"
				class="btn btn-bertazzoni black rounded-0 py-2 ml-2"
				(click)="sendOrder(modal, alert)"
				[disabled]="!dateSelected || !rifOrdineCliente">
				Save
			</button>
		</div>
	</ng-template>

	<ng-template #t let-date let-focused="focused" let-selected="selected">
		<!-- Questo e l'HTML della singola cella del giorno dove vedi class. -> focused se ci ho cliccato, range -> se é dentro il range, faded -> se é dentro il range ma in mezzo tra le prima e l ultima -->
		<!-- Quindi solo range: o la prima o l'ultima range+faded: in mezzo al range, focused+range: quella che ho appena cliccato -->
		<span class="custom-day" [class.focused]="focused" [class.range]="selected">
			{{ date.day }}
		</span>
	</ng-template>

	<ng-template #contentMail let-modalmail>
		<div class="modal-header">
			<h5 class="modal-title" id="">Send an E-Mail</h5>
			<button type="button" class="close" aria-label="Close" (click)="modalmail.close()">
				<span aria-hidden="true">&times;</span>
			</button>
		</div>
		<div class="modal-body">
			<form #formMail="ngForm">
				<div class="row">
					<div class="col-12">
						<label class="font-14">Sender</label>
						<input
							type="text"
							class="form-control mb-2 rounded-0 form-bertazzoni white disabled"
							placeholder="SENDER*"
							name="sender"
							[(ngModel)]="jsonInMail.sender"
							required
							disabled />
					</div>
					<div class="col-12">
						<label class="font-14">Recipients* ( separated by semicolon ';' )</label>
						<input
							type="text"
							class="form-control mb-2 rounded-0 form-bertazzoni white"
							placeholder="RECIPIENTS* ( separated by semicolon ';' )"
							name="recipients"
							[(ngModel)]="jsonInMail.recipients"
							required />
					</div>
					<div class="col-12 mt-3">
						<input
							type="text"
							class="form-control mb-2 rounded-0 form-bertazzoni white"
							placeholder="SUBJECT*"
							name="subject"
							[(ngModel)]="jsonInMail.subject"
							required />
					</div>
					<div class="col-12 mt-1">
						<textarea
							type="text"
							class="form-control mb-2 rounded-0 form-bertazzoni white"
							style="height: auto;"
							placeholder="BODY"
							rows="10"
							name="body"
							[(ngModel)]="jsonInMail.body"></textarea>
					</div>
					<div class="col-12" *ngIf="mailError">
						<p class="ont-16 mb-0 mt-1 text-danger">{{mailError | translate}}</p>
					</div>
					<div class="col-12 mt-2 d-flex">
						<p class="ont-16 mb-0 mt-1">Attachments:</p>
						<button
							class="btn btn-bertazzoni black btn-block rounded-0 mt-0 ml-3"
							style="width: 15% !important;"
							(click)="getPdfCarrello()">
							PDF
						</button>
						<button class="btn btn-bertazzoni black btn-block rounded-0 mt-0 w-25 ml-auto" (click)="modalmail.close()">CLOSE</button>
						<button
							class="btn btn-bertazzoni black btn-block rounded-0 mt-0 w-25 ml-3"
							[class.disabled]="formMail.invalid"
							[disabled]="formMail.invalid"
							(click)="sendMail(modalmail, mailSuccess)">
							SEND
						</button>
					</div>
				</div>
			</form>
		</div>
	</ng-template>

	<ng-template #mailSuccess let-modalmailsuccess>
		<div class="modal-header">
			<h5 class="modal-title" id="">E-Mail Sent !</h5>
			<button type="button" class="close" aria-label="Close" (click)="modalmailsuccess.close()">
				<span aria-hidden="true">&times;</span>
			</button>
		</div>
	</ng-template>

	<ng-template #alert let-modalalert>
		<div class="modal-header">
			<h5 class="modal-title" id="">{{alertMessage}}</h5>
			<button type="button" class="close" aria-label="Close" (click)="modalalert.close()">
				<span aria-hidden="true">&times;</span>
			</button>
		</div>
	</ng-template>

	<ng-template #confirm let-modalconfirm>
		<div class="modal-header">
			<h5 class="modal-title" id="" translate>prodotti.senza.accessori.titolo</h5>
			<button type="button" class="close" aria-label="Close" (click)="modalconfirm.dismiss('close')">
				<span aria-hidden="true">&times;</span>
			</button>
		</div>
		<div class="modal-body">
			<div class="col-12">
				<p class="font-20" translate>prodotti.senza.accessori.descrizione</p>
			</div>
		</div>
		<div class="modal-footer">
			<button type="button" class="btn btn-bertazzoni white rounded-0 py-2 mr-2" (click)="modalconfirm.dismiss('close')">Close</button>
			<button type="button" class="btn btn-bertazzoni black rounded-0 py-2" (click)="modalconfirm.close()">OK</button>
		</div>
	</ng-template>
</div>
